import { TextField, TextFieldProps } from "@mui/material";
import { useEffect, useState } from "react";
import { NumericFormat, NumericFormatProps, numericFormatter } from "react-number-format";

export type NumberFieldProps = Omit<NumericFormatProps, "size"> & Omit<TextFieldProps, "type"> & {
    alignRight?: boolean
};

export default function NumberField({
    thousandSeparator = ".",
    decimalSeparator = ",",
    decimalScale = 2,
    allowNegative = false,
    alignRight = true,
    value,
    onValueChange,
    ...props
}: NumberFieldProps) {
    const [localValue, setLocalValue] = useState(String(value));

    function formatNumber(number: number | string | null | undefined) {
        if (number == null || number === "") return "";
        const tens = Math.pow(10, decimalScale);
        return numericFormatter(String(Math.round(Number(number) * tens) / tens), { thousandSeparator, decimalSeparator, decimalScale });
    }

    useEffect(() => {
        if (formatNumber(localValue) !== formatNumber(value)) setLocalValue(String(value))
    }, [value])

    return <NumericFormat
        {...props}

        thousandSeparator={thousandSeparator}
        decimalSeparator={decimalSeparator}
        decimalScale={decimalScale}
        allowNegative={allowNegative}

        customInput={TextField}

        value={localValue}
        onValueChange={(values, s) => {
            setLocalValue(values.value);
            onValueChange && onValueChange(values, s);
        }}

        sx={{ input: { textAlign: alignRight ? "right" : undefined }, ...props.sx }}
    />
}